(function () {
  // NOTE: Dawn/Swatch King can REPLACE the product-info DOM (and the sticky
  // bar inside it) on variant changes. Never cache element references - always
  // re-query, and use event delegation for clicks.

  function bar() { return document.getElementById('sticky-atc'); }
  function mainAtc() {
    return (
      document.querySelector('product-info .product-form__submit') ||
      document.querySelector('.product-form__submit')
    );
  }

  // --- 1) Reveal: show the bar when the main add-to-cart button is out of
  // view OR the shopper has scrolled a full viewport (the info column is
  // position:sticky on desktop, so the button may never leave the viewport).
  function update() {
    var el = bar();
    if (!el) return;
    var m = mainAtc();
    var mainVisible = false;
    if (m) {
      var r = m.getBoundingClientRect();
      mainVisible = r.bottom > 0 && r.top < window.innerHeight && r.height > 0;
    }
    var scrolledPast = window.scrollY > window.innerHeight;
    if (!mainVisible || scrolledPast) {
      el.classList.remove('hidden');
    } else {
      el.classList.add('hidden');
    }
  }
  var scrollTick = false;
  window.addEventListener('scroll', function () {
    if (scrollTick) return;
    scrollTick = true;
    setTimeout(function () { scrollTick = false; update(); }, 120);
  }, { passive: true });
  window.addEventListener('resize', function () { setTimeout(update, 120); }, { passive: true });
  // Settle-in checks (covers re-renders that replace the bar element)
  var polls = 0;
  var poller = setInterval(function () {
    polls++;
    update();
    syncPrice();
    if (polls > 20) clearInterval(poller);
  }, 500);
  update();

  // --- 2) Price: mirror the main PDP price into the bar (re-query each time).
  function readMainPriceText() {
    var p = document.querySelector('product-info .price');
    if (!p) return '';
    if (p.classList.contains('price--on-sale')) {
      var s = p.querySelector('.price-item--sale');
      if (s) return s.textContent.trim();
    }
    var r = p.querySelector('.price-item--regular');
    return r ? r.textContent.trim() : '';
  }
  function syncPrice() {
    var el = bar();
    if (!el) return;
    var target = el.querySelector('[data-sticky-atc-price]');
    var val = readMainPriceText();
    if (target && val && target.textContent !== val) target.textContent = val;
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects, variant-radios')) {
      setTimeout(syncPrice, 200);
      setTimeout(function () { syncPrice(); update(); }, 800);
    }
  });
  syncPrice();

  // --- 3) Add to cart: hand off to the real product form (event delegation
  // survives bar re-renders).
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sticky-atc-button]');
    if (!b) return;
    var m = mainAtc();
    var disabled = m && (m.disabled || m.getAttribute('aria-disabled') === 'true');
    if (m && !disabled) {
      m.click();
    } else {
      var picker =
        document.querySelector('product-info variant-selects') ||
        document.querySelector('variant-selects') || m;
      if (picker) {
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        picker.classList.add('sticky-atc-flash');
        setTimeout(function () { picker.classList.remove('sticky-atc-flash'); }, 1200);
      }
    }
  });
})();
